import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  type ButtonProps,
} from "@mui/material";
import { type FC, type ReactNode } from "react";
import { useDialog } from "../../../../../../utils/hooks/use-dialog";
import { ChannelIcon } from "../../../../../channels/components/channel-icon";
import type { ChannelName } from "../../../../../channels/types";
import { prettyChannelName } from "../../../../../channels/utils";

type Props = {
  persons: number;
  channel: ChannelName;
  buttonText: string;
  children: ReactNode;
} & ButtonProps;

export const PreviewPersonsButton: FC<Props> = ({
  persons,
  buttonText,
  channel,
  children,
  ...buttonProps
}) => {
  const dialog = useDialog();

  return (
    <>
      <Button
        variant="text"
        color={persons === 0 ? "error" : "primary"}
        disabled={persons === 0}
        endIcon={
          <Stack direction="row">
            <ChannelIcon channel={channel} fontSize="small" />
            <Typography variant="body2">{persons}</Typography>
          </Stack>
        }
        onClick={() => dialog.handleOpen("persons")}
        data-analytics-id="people-in-segment-channel-button"
        {...buttonProps}
      >
        {buttonText}
      </Button>
      <Dialog open={dialog.open} onClose={dialog.handleClose} fullWidth maxWidth="md">
        <DialogTitle>People in Segment Group for {prettyChannelName(channel)}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={dialog.handleClose} data-analytics-id="people-in-segment-close-button">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
